import React, { lazy } from 'react';
import { motion } from 'framer-motion';
import { ArrowUpRightIcon, CircleIcon, MessageCircleIcon } from 'lucide-react';
import { PORTFOLIO_PROJECTS, SITE_CONFIG, WHATSAPP_MESSAGES } from '../config/siteConfig';
import { createWhatsAppUrl, trackEvent } from '../utils/analytics';
export function PortfolioSection() {
  return <section id="ejemplos" className="bg-[#050511] py-16 md:py-20" aria-labelledby="ejemplos-title" data-id="element-1067">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8" data-id="element-1068">
        <div className="max-w-3xl" data-id="element-1069">
          <p className="mb-3 text-sm font-semibold uppercase tracking-[0.16em] text-[#20d6e8]" data-id="element-1070">
            Proyectos reales
          </p>
          <h2 id="ejemplos-title" className="text-3xl font-bold text-white md:text-5xl" data-id="element-1071">
            Así puede verse tu negocio en Internet.
          </h2>
          <p className="mt-4 text-lg leading-relaxed text-[#a9a9ba]" data-id="element-1072">
            Diseñamos cada página según la identidad, servicios y objetivos de
            cada negocio.
          </p>
        </div>

        <div className="mt-9 grid gap-5 md:grid-cols-2 lg:grid-cols-3" data-id="element-1073">
          {PORTFOLIO_PROJECTS.map((project, index) => {
          const isInternalProject = project.url === '#';
          return <motion.article key={project.name} initial={{
            opacity: 0,
            y: 18
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: index % 3 * 0.07
          }} className="overflow-hidden rounded-2xl border border-white/10 bg-[#101022]" data-id="element-1074">
                <div className="relative aspect-[16/10] overflow-hidden bg-[#0c0c1c]" data-id="element-1075">
                  <img src={project.previewUrl} alt={`Vista previa del proyecto ${project.name}`} loading="lazy" className="h-full w-full object-cover object-top opacity-90 transition duration-500 hover:scale-[1.03]" data-id="element-1076" />
                  <div className="pointer-events-none absolute inset-0 bg-gradient-to-t from-[#101022] via-transparent to-transparent" data-id="element-1077" />
                  <div className="absolute right-3 top-3 inline-flex items-center gap-1.5 rounded-full border border-white/15 bg-[#050511]/80 px-2.5 py-1 text-[10px] font-bold uppercase tracking-[0.12em] text-white backdrop-blur" data-id="element-1078">
                    <CircleIcon className="h-2 w-2 fill-[#25d366] text-[#25d366]" data-id="element-1079" />
                    Sitio activo
                  </div>
                  {'recommendedForRestaurants' in project && project.recommendedForRestaurants && <p className="absolute bottom-3 left-3 rounded-full border border-[#67d19b]/50 bg-[#07150f]/90 px-3 py-1.5 text-[10px] font-bold uppercase tracking-[0.1em] text-[#a7f0c7] backdrop-blur" data-id="element-1080">
                        Ejemplo recomendado para restaurantes
                      </p>}
                </div>

                <div className="p-5" data-id="element-1081">
                  <p className="text-xs font-semibold uppercase tracking-[0.14em]" style={{
                color: project.accent
              }} data-id="element-1082">
                    {project.category}
                  </p>
                  <h3 className="mt-2 text-xl font-bold text-white" data-id="element-1083">
                    {project.name}
                  </h3>
                  <p className="mt-3 text-sm leading-relaxed text-[#a9a9ba]" data-id="element-1084">
                    {project.description}
                  </p>
                  <a href={project.url} target={isInternalProject ? undefined : '_blank'} rel={isInternalProject ? undefined : 'noopener noreferrer'} onClick={() => trackEvent('portfolio_project_click', {
                cta_location: 'portfolio',
                project_name: project.name
              })} className="mt-5 inline-flex min-h-11 items-center gap-2 text-sm font-semibold text-white transition-colors hover:text-[#20d6e8] focus:outline-none focus-visible:ring-2 focus-visible:ring-[#20d6e8]" data-id="element-1085">
                    Ver proyecto
                    <ArrowUpRightIcon className="h-4 w-4" data-id="element-1086" />
                  </a>
                </div>
              </motion.article>;
        })}
        </div>

        <div className="mt-8 rounded-2xl border border-[#25d366]/25 bg-[#101022] px-5 py-6 sm:flex sm:items-center sm:justify-between sm:gap-6 sm:px-7" data-id="element-1087">
          <div data-id="element-1088">
            <h3 className="text-xl font-bold text-white" data-id="element-1089">
              ¿Querés una página así para tu negocio?
            </h3>
            <p className="mt-2 text-sm text-[#a9a9ba]" data-id="element-1090">
              Contanos sobre tu negocio y revisamos la versión más conveniente.
            </p>
          </div>
          <a href={createWhatsAppUrl(WHATSAPP_MESSAGES.portfolio)} target="_blank" rel="noopener noreferrer" onClick={() => trackEvent('portfolio_cta_click', {
          cta_location: 'portfolio_after_examples',
          selected_product: SITE_CONFIG.product.name
        })} className="mt-5 inline-flex min-h-12 shrink-0 items-center justify-center gap-2 rounded-xl bg-[#25d366] px-5 py-3 text-sm font-semibold text-[#06170c] transition-colors hover:bg-[#3ee47a] focus:outline-none focus-visible:ring-2 focus-visible:ring-white sm:mt-0" data-id="element-1091">
            <MessageCircleIcon className="h-5 w-5" data-id="element-1092" />
            Cotizar la mía por WhatsApp
          </a>
        </div>
      </div>
    </section>;
}